import React, { useEffect } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";

import { Spacer } from "../../../../../components/Spacer";
import { useInput } from "../../../../../hooks/useInput";
import { Checkbox } from "../../../../../components/Checkbox";
import { useOnChange } from "../../../../../hooks/useOnChange";
import { InputText } from "../../../../../components/InputText";
import { InputNumber } from "../../../../../components/InputNumber";

const Overview3dAreaItemStyle = styled.div`
    border: 1px solid ${props => props.theme.greyLight};
    outline: ${props => (props.$active
        ? `1px solid ${props.theme.primaryLight}`
        : props.$highlighted
            ? `1px solid ${props.theme.greenLight}`
            : "none")};
    padding: 10px;
    border-radius: 2px;

    >div:nth-child(1) {
        margin-bottom: 10px;
        display: grid;
        grid-template-columns: 2.5fr 1fr 1fr;
        gap: 8px;
        align-items: flex-end;
    }
    >div:nth-child(2) {
        display: flex;
        gap: 8px;
        align-items: flex-end;
        justify-content: end;
    }
`;

export const Overview3dAreaItem = props => {
    const { calcArea, index, active, highlighted, isVisible, onVisibilityChanged } = props;

    const layerName = "ws-area-" + index;

    const areaName = useInput(`${layerName}-name`, calcArea.name);
    const visible = useInput(`${layerName}-visible`, isVisible);
    const height = useInput(`${layerName}-height`,
        calcArea.originZ !== undefined && calcArea.vaxisZ !== undefined ? calcArea.originZ + calcArea.vaxisZ : undefined);
    const heightLow = useInput(`${layerName}-heightLow`, calcArea.originZ);

    useOnChange((_, value) => {
        onVisibilityChanged(value);
    }, [visible]);

    useEffect(() => {
        if (visible.value !== isVisible) {
            visible.set(isVisible);
            visible.value = isVisible;
        }
    }, [isVisible]);

    return (
        <>
            <Overview3dAreaItemStyle
                $active={active}
                $highlighted={highlighted}>
                <div>
                    <InputText {...areaName.bind}
                        disabled={true}
                        maxLength="30"
                        title={intl.get("entry.plan.areas.name")} />
                    <div>
                        <InputNumber {...height.bind}
                            title={intl.get("entry.plan.areas.height")}
                            fractionDigits={2}
                            disabled={true} />
                    </div>
                    <div>
                        <InputNumber {...heightLow.bind}
                            title={intl.get("entry.plan.areas.heightLow")}
                            fractionDigits={2}
                            disabled={true} />
                    </div>
                </div>
                <div>
                    <Checkbox {...visible.bind}
                        title={intl.get("entry.plan.worstcase.visible")} />
                </div>
            </Overview3dAreaItemStyle>
            <Spacer variant="horizontal" />
        </>
    );
};
